import { useSubscription } from '@/src/context/SubscriptionContext';
import { useEffect } from 'react';
import { View } from 'react-native';

export interface AdBannerWebProps {
  colors: { background: string; border: string };
}

/**
 * AdBanner for web using Google AdSense.
 * The AdSense script must be loaded in web/index.html.
 * Ad units IDs come from EXPO_PUBLIC_ADSENSE_CLIENT_ID and EXPO_PUBLIC_ADSENSE_SLOT_BANNER env vars.
 */
export const AdBannerWeb = ({ colors }: AdBannerWebProps) => {
  const { isPro } = useSubscription();

  useEffect(() => {
    if (isPro) return;
    try {
      (window as any).adsbygoogle = (window as any).adsbygoogle || [];
      (window as any).adsbygoogle.push({});
    } catch {
      // AdSense script not loaded yet — will be auto-initialized by script tag
    }
  }, []);

  if (isPro) return null;

  const clientId = process.env.EXPO_PUBLIC_ADSENSE_CLIENT_ID;
  const slotId = process.env.EXPO_PUBLIC_ADSENSE_SLOT_BANNER;

  if (!clientId || !slotId) return null;

  return (
    <View
      style={{
        backgroundColor: colors.background,
        borderTopWidth: 1,
        borderBottomWidth: 1,
        borderColor: colors.border,
        paddingVertical: 4,
        alignItems: 'center',
        minHeight: 60,
      }}
    >
      {/* @ts-ignore — <ins> is a valid DOM element in React Native Web */}
      <ins
        className="adsbygoogle"
        style={{ display: 'block', width: '100%', minHeight: 50 }}
        data-ad-client={clientId}
        data-ad-slot={slotId}
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </View>
  );
};
